<template>
    <el-image-viewer 
		v-if="show" 
		v-bind="$attrs" 
		@close="show = false" 
	/>
</template>
 
<script setup>
import { ref, watch, onMounted, onUnmounted } from "vue";
import { ElImageViewer } from "element-plus";

const props = defineProps({
    visible: {
        type: Boolean,
        default: false,
    },
    remove: {
        type: Function, //传入createApp中移除节点的方法
        default: null,
    },
    // api文档：https://element-plus.org/zh-CN/component/image.html#image-viewer-attributes
})
// onMounted(()=>{
// 	document.addEventListener('keydown', listenerESCkeydown ,false);
// })
// onUnmounted(()=>{
// 	document.removeEventListener('keydown', listenerESCkeydown ,false);
// 	console.log('图片预览卸载');
// })
// let listenerESCkeydown = (event)=>{
// 	console.log('键盘事件',event);
// 	if (event.key === "Escape" || event.keyCode === 27) {
// 		console.log('Esc键被按下了。');
// 		event.preventDefault();
// 	}
// }

const show = ref(props.visible)
// 监听显示的消失，需要移除dom
watch(() => show.value, (val) => {
    !val && props.remove()
})
</script>
